<template>
    <div class="row">
        <div class="col-lg-12">
            <h3 class="mt">
                <span>Адреса реєстрації страхувальника</span>
            </h3>
        </div>
        <div class="col-lg-12 row passport-row">
            <div class="col-lg-6">
                <div class="form-group">
                    <multiselect
                        @select="getClientDataForUpdating"
                        :class="['form-control', 'choice_city', { invalid: (!$v.payer.city.required && $v.payer.city.$error) }]"
                        v-model="payer.city"
                        :options="citiesOptions"
                        placeholder="Введіть назву міста"
                        @search-change="searchCities"
                        :internal-search="false"
                        :max-height="165"
                        :options-limit="300"
                        :allow-empty="false"
                        label="name_full_name_ua"
                    />
                    <small class="error" v-if="!$v.payer.city.required && $v.payer.city.$error">Вкажіть місто прописки</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model="payer.street"
                        @change="getClientDataForUpdating"
                        type="text"
                        placeholder="Вул."
                        :class="['form-control', { invalid: ((!$v.payer.street.required && $v.payer.street.$error) || (!$v.payer.street.customMinLength)) }]"
                    />
                    <small class="error" v-if="!$v.payer.street.customMinLength">Вкажіть вулицю мін. 4 літер</small>
                    <small class="error" v-if="!$v.payer.street.required && $v.payer.street.$error">Вкажіть вулицю</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model="payer.house"
                        @change="getClientDataForUpdating"
                        v-on:keypress="LetterNumSymbolsMask"
                        type="text"
                        placeholder="Номер будинку"
                        :class="['form-control', { invalid: ((!$v.payer.house.required && $v.payer.house.$error) || (!$v.payer.house.minLength) || (!onlyLatinAndNumAndSpecials(payer.house))) }]"
                    />
                    <small class="error" v-if="!$v.payer.house.required && $v.payer.house.$error">Вкажіть № будинку</small>
                    <small class="error" v-if="LetterMaskError || ($v.payer.house.$error && !onlyLatinAndNumAndSpecials(payer.house))">Тільки цифри, латинські літери, кирилиця та символи "-/"</small>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <input
                        v-model="payer.apartment"
                        @change="getClientDataForUpdating"
                        v-on:keypress="LetterNumSymbolsMask"
                        type="text"
                        placeholder="Квартира"
                        :class="['form-control', { invalid: ((!$v.payer.apartment.minLength) || (!onlyLatinAndNumAndSpecials(payer.apartment))) }]"
                    />
                    <small class="error" v-if="!$v.payer.apartment.minLength && $v.payer.apartment.$error">Вкажіть № квартири</small>
                    <small class="error" v-if="LetterMaskError || (!onlyLatinAndNumAndSpecials(payer.apartment))">Тільки цифри, латинські літери, кирилиця та символи "-/"</small>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import {maxLength, minLength, required} from "vuelidate/lib/validators";

export default {
    components: { Multiselect },
    props: ['payer', 'citiesOptions'],

    data() {
        return {
            LetterMaskError: false,
        };
    },

    model: {
        prop: 'payer',
        event: 'change',
    },

    validations: {
        payer: {
            city: { required, minLength: minLength(1) },
            street: {
                required,
                customMinLength(value) {
                    if (this.payer.street == null || this.payer.street == "") {
                        return true;
                    }
                    return value !== null && value?.length >= 4;
                }
            },
            house: { required, minLength: minLength(1), onlyLatinAndNumAndSpecials(value) { return this.onlyLatinAndNumAndSpecials(value); } },
            apartment: { minLength: minLength(1), onlyLatinAndNumAndSpecials(value) { return this.onlyLatinAndNumAndSpecials(value); } },
        },
    },

    methods: {
        getClientDataForUpdating() {
            this.$emit('getClientDataForUpdating');
        },

        LetterNumSymbolsMask(e) {
            let char = String.fromCharCode(e.keyCode);
            if (/^[A-Za-z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(char)) {
                this.LetterMaskError = false;
                return true;
            } else {
                this.LetterMaskError = true;
                e.preventDefault();
            }
        },

        LetterCyrMask(e) {
            let char = String.fromCharCode(e.keyCode);
            if(/^[А-Яа-яЇїІіҐґ+'ʼЄє` ]+$/.test(char)) {
                this.LetterMaskError = false;
                return true;
            } else {
                this.LetterMaskError = true;
                e.preventDefault();
            }
        },

        onlyLatinCharactersAndNum(str) {
            if (str == undefined || str == null || str == "") return true;
            return /^[a-zA-Z0-9 ]+$/.test(str);
        },

        onlyLatinAndNumAndSpecials(str) {
            if (str == null || str == "") return true;
            if (/^[a-zA-Z0-9а-яґєіїА-ЯЄҐЇІ\-.\/ ]+$/.test(str)) {
                return /\d/.test(str);
            }
            return false;
        },

        onlyCyrCharacters(str) {
            if(str == null || str == "") return true;
            return /^[А-Яа-яЇїІіҐґ'ʼЄєщЩ`\- ]+$/.test(str);
        },

        hasError(name, index = false) {
            if (!index) {
                return this.errors[name] !== undefined;
            } else {
                if (!!this.errors[name]) {
                    return this.errors[name][index] !== undefined;
                } else {
                    return false;
                }
            }
        },

        searchCities(query) {
            this.$emit('searchCities', query);
        },
    },
}
</script>
